import {Component,Input, ViewChild} from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
export interface ConfirmModel {
  title:string;
  message:string;
  data :any ;
    showcancel : boolean;

}
@Component({  
    selector: 'confirm',
    template: `<div class="vertical-alignment-helper">
    <div class="modal-dialog" style="top:-30px;left:100px">
                <div class="modal-content" style="overflow-y: auto;word-wrap: break-word;width:400px;">
         
                     <div class="poupupTitle">
                     <h5 class="modal-title">{{title || 'Confirm'}}</h5>
                   </div>
               
               
                   <div class="modal-body">
                  <div class="firstPopup">
                     <p>{{message || 'Are you sure?'}}</p>
                    <table>
          <thead>
          </thead>
          <tbody *ngIf ="data.length !=0" class="table">
              <tr >
                <th class="popuptd"> Name</th>
                <th class="popuptd" > Description</th>
                   <th class="popuptd" > Image</th>
              </tr>
              <tr *ngFor = ' let item of data'  >
                  <td class="popuptd" >{{item.name}}</td>
                  <td style="width:300px" class="popuptd" >{{item.description}}</td>
                    <td class="popuptd"><img style=" width: 50px;border-radius: 50%;" src="{{item.imgUrl}}"></td>
              </tr>
          </tbody>
      </table>
                  
                     </div>
                   </div>
 <div class="modal-footer">
                     <button type="button" class="btn btn-default btn-orange" *ngIf="!showcancel"  (click)="confirm()">OK</button>
                 <button type="button" class="btn btn-default btn-orange " (click)="confirm()" *ngIf="showcancel" >Yes</button>
                     <button type="button" class="btn btn-default btn-orange " (click)="close()" *ngIf="showcancel" >No</button>
                   </div>
                 </div>
              </div></div>`
})
export class PopupSegmentComponent extends DialogComponent<ConfirmModel, boolean> implements ConfirmModel {
  title: string;
  message: string;
  data : any;
  showcancel : boolean;
  constructor(dialogService: DialogService) {
    super(dialogService);
  }
  confirm() {
    this.result = true;
    this.close();
  }

  
}



// WEBPACK FOOTER //
// ./src/app/admin/shared/components/popupAdmin/popup-segment.component.ts